import { render } from "./KioskPreRegPostEdit.vue?vue&type=template&id=9c467e9c"
import script from "./KioskPreRegPostEdit.vue?vue&type=script&lang=js"
export * from "./KioskPreRegPostEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__